import * as React from "react";
import { usePlayerStateData } from "../../context/PlayerStateContext";
export var PlayerProgress = function () {
    var _a = usePlayerStateData(), progress = _a.progress, timeLeftSide = _a.timeLeftSide, timeRightSide = _a.timeRightSide;
    return (React.createElement("div", { className: "progress-wrapper" },
        React.createElement("div", { className: "current-time" }, timeLeftSide),
        React.createElement("div", { className: "progress" },
            React.createElement("div", { className: "progress-bar", style: "width: " + progress * 100 + "%" })),
        React.createElement("div", { className: "time-left" }, timeRightSide)));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/player/PlayerProgress.tsx
// module id = 193
// module chunks = 1